import React from 'react';
import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { deleteModalMessages as messages } from './PremiumCaps.messages';

const DeletePremiumCapsRuleModal = props => (
  <Confirm
    title={<Message message={messages.title} />}
    acceptNode={<Message message={messages.accept} />}
    cancelNode={<Message message={messages.cancel} />}
    {...props}>
    <Message message={messages.body} />
  </Confirm>
);

export default DeletePremiumCapsRuleModal;
